module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "logo-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.logoLabel')
    }
  }, [_c('order-logo-dialog', {
    ref: "order-logo-dialog"
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "selector",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "default"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.default')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.custom')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "hide"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.hide')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "logo-content"
  }, [(_vm.type === 'default') ? _c('div', {
    staticClass: "default"
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.logo.default')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'custom') ? _c('div', {
    staticClass: "custom"
  }, [(_vm.editable) ? _c('image-uploader', {
    staticClass: "logo-wrapper",
    attrs: {
      "tag": "logo",
      "title": _vm.$t('actions.project.settings.logo.cover')
    },
    model: {
      value: (_vm.logo),
      callback: function($$v) {
        _vm.logo = $$v
      },
      expression: "logo"
    }
  }) : _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.settings.logo.price'))), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.openOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.priceBtn')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'hide') ? _c('div', {
    staticClass: "hide"
  }, [(_vm.editable) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.logo.hide')))]) : _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.settings.logo.price'))), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.openOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.priceBtn')))])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9db90b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/logo.card.vue
// module id = 939
// module chunks = 3